const RECENT_ACTIVITY = [
  {
    title: '钱包流水更新',
    sub: '订单 ORD-20250528-001',
    amount: '+CNY 550.000000',
    type: 'success',
  },
  {
    title: '充值到账',
    sub: 'WXPAY · 订单 ORD-20250527-088',
    amount: '+CNY 10.000000',
    type: 'success',
  },
  {
    title: '钱包流水更新',
    sub: '订单 ORD-20250526-042',
    amount: '-CNY 0.500000',
    type: 'default',
  },
  {
    title: 'API 调用扣费',
    sub: 'byt-claude-sonnet-4 · 128 tokens',
    amount: '-CNY 0.012000',
    type: 'default',
  },
];

const WALLET_FLOW = [
  { time: '2025-05-28 14:32', type: '充值', amount: '+¥10.00', balance: '¥560.00' },
  { time: '2025-05-28 10:15', type: '充值', amount: '+¥550.00', balance: '¥550.00' },
  { time: '2025-05-27 18:40', type: '消费', amount: '-¥0.50', balance: '¥0.00' },
];

const Overview = () => (
  <>
    <div className="console-stats">
      <div className="console-stat-card">
        <div className="console-stat-label">可用余额</div>
        <div className="console-stat-value highlight">¥560.000000</div>
      </div>
      <div className="console-stat-card">
        <div className="console-stat-label">活跃令牌</div>
        <div className="console-stat-value">1</div>
      </div>
      <div className="console-stat-card">
        <div className="console-stat-label">累计请求</div>
        <div className="console-stat-value">0</div>
      </div>
      <div className="console-stat-card">
        <div className="console-stat-label">邀请人数</div>
        <div className="console-stat-value">0</div>
      </div>
    </div>

    <div className="console-grid-2">
      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">最近动态</h3>
          <button type="button" className="console-card-action">
            日志
          </button>
        </div>
        <div className="console-card-body">
          <ul className="console-activity-list">
            {RECENT_ACTIVITY.map((item) => (
              <li key={`${item.title}-${item.sub}`} className="console-activity-item">
                <span className={`console-activity-dot ${item.type}`} />
                <div className="console-activity-main">
                  <div className="console-activity-title">{item.title}</div>
                  <div className="console-activity-sub">{item.sub}</div>
                </div>
                <span
                  className="console-activity-amount"
                  style={item.amount.startsWith('-') ? { color: 'var(--muted)' } : undefined}
                >
                  {item.amount}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">账户态势</h3>
        </div>
        <div className="console-card-body">
          <div className="console-status-grid">
            <div className="console-status-item">
              <div className="console-status-label">钱包余额</div>
              <div className="console-status-value primary">¥560.000000</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">冻结金额</div>
              <div className="console-status-value">¥0.000000</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">已结算返利</div>
              <div className="console-status-value">¥0.000000</div>
            </div>
            <div className="console-status-item">
              <div className="console-status-label">邀请码</div>
              <div className="console-status-value">LVCHUNLC</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="console-grid-2">
      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">钱包最新流水</h3>
          <button type="button" className="console-card-action">
            全部
          </button>
        </div>
        <div className="console-card-body console-table-wrap">
          <table className="console-table">
            <thead>
              <tr>
                <th>时间</th>
                <th>类型</th>
                <th>金额</th>
                <th>余额</th>
              </tr>
            </thead>
            <tbody>
              {WALLET_FLOW.map((row) => (
                <tr key={row.time}>
                  <td>{row.time}</td>
                  <td>{row.type}</td>
                  <td style={{ color: row.amount.startsWith('+') ? 'var(--accent)' : undefined }}>
                    {row.amount}
                  </td>
                  <td>{row.balance}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="console-card">
        <div className="console-card-header">
          <h3 className="console-card-title">邀请与返利</h3>
          <button type="button" className="console-card-action">
            全部
          </button>
        </div>
        <div className="console-card-body">
          <div className="console-empty">
            <span className="console-empty-icon">🎁</span>
            <p>暂无返利记录</p>
            <p style={{ fontSize: '0.8125rem' }}>分享邀请码 LVCHUNLC 邀请好友注册</p>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Overview;
